module.exports = __webpack_public_path__ + "img/fa.66bd7901.svg";